import { baseQueryClient } from '@aibees/shared/http';
import { SocketMessageType, useSocketEvent } from '@aibees/shared/socket';
import { useGetSocketChannel } from '@aibees/shared/socket/hooks/use-get-socket-channel';
import { debounce } from 'lodash-es';
import { useRef } from 'react';
import { useBrowsePaymentCardApi } from '../api/use-browse-payment-card-api';
import { PaymentMethodSocketMessage } from './types';

export function usePaymentMethodUpdateSocketListener() {
  const channel = useGetSocketChannel(SocketMessageType.PAYMENT_METHOD);

  const debouncedInvalidate = useRef(
    debounce(
      () => baseQueryClient.invalidateQueries([useBrowsePaymentCardApi.name]),
      500
    )
  ).current;

  useSocketEvent(channel, (data: PaymentMethodSocketMessage) => {
    if (data.type === SocketMessageType.PAYMENT_METHOD) {
      debouncedInvalidate();
    }
  });
}
